import { createAction } from 'redux-act'

const fetchNewsStart = createAction('NEWS/fetch start')
const fetchNewsSuccess = createAction<any>('NEWS/fetch success')
const fetchNewsFail = createAction<any>('NEWS/fetch fail')

export default {
  fetchNewsStart,
  fetchNewsSuccess,
  fetchNewsFail,
}
